export default "__VITE_ASSET__CgWw_xAe__";